/** Vector design view of a wall-mounted surveillance camera. */
export function CameraFrontView({ x = 0, y = 0, width = 24, height = 24 }: {
  x?: number; y?: number; width?: number; height?: number;
}) {
  return (
    <svg x={x} y={y} width={width} height={height} viewBox="0 0 24 24" pointerEvents="none" aria-hidden="true">
      <g stroke="#475569" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2.5" y="15.5" width="2" height="6" rx="0.5" fill="#dbe3e9" />
        <path d="M4.5 18.5h4l2-5" fill="none" stroke="#94a3b8" strokeWidth="1.8" />
        <path d="m4 5 15 3.8-1.8 7L3 12Z" fill="#f8fafc" />
        <path d="m4 5 15 3.8-.6 1.7L3.6 6.8Z" fill="#e2e8f0" />
        <path d="m17 8.3 2 .5-1.8 7-2-.5Z" fill="#cbd5e1" />
        <path d="m18.7 10.6 2.5 .7-.9 3.5-2.5-.6Z" fill="#334155" />
        <ellipse cx="20.3" cy="12.7" rx="0.65" ry="1.2" transform="rotate(15 20.3 12.7)" fill="#7dd3fc" />
      </g>
    </svg>
  );
}
